import DeviceLookupPage from './DeviceLookupPage';
export default DeviceLookupPage;
